import React from 'react';

const Check = () => (
  <svg className="cf-role__check" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.4} aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const roles = [
  {
    title: 'Team Captains',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    ),
    features: ['Free squad management', 'Challenge rival teams', 'Start scoring any game'],
  },
  {
    title: 'Players',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
    features: ['Build your cricket profile', 'Track your career stats', 'View every scorecard'],
  },
  {
    title: 'Organizers',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
      </svg>
    ),
    features: ['Run free tournaments', 'Automated points tables', 'Manage all scorecards'],
  },
  {
    title: 'Umpires & Scorers',
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    features: ['Simple scoring interface', 'Update scores ball-by-ball', 'Keep scorecards accurate'],
  },
];

const WhoIsThisFor = () => {
  return (
    <section className="cf-section">
      <div className="cf-container cf-rel-z">
        <div className="cf-section-head cf-reveal">
          <span className="cf-eyebrow">Who it's for</span>
          <h2 className="cf-h2">
            Made for every role
            <br />
            <span className="cf-text-gradient">on the pitch</span>
          </h2>
        </div>
      </div>

      {/* Carousel breaks out of the container so cards can bleed to the edge */}
      <div className="cf-roles">
        {roles.map((role, i) => (
          <div
            key={role.title}
            className="cf-role cf-reveal"
            style={{ '--cf-d': `${i * 0.08}s` }}
          >
            <div className="cf-role__ic">{role.icon}</div>
            <h3 className="cf-role__title">{role.title}</h3>
            <ul className="cf-role__list">
              {role.features.map((feature, j) => (
                <li key={j}><Check />{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhoIsThisFor;
